import { render, staticRenderFns } from "./PeoplePicker.vue?vue&type=template&id=0f2f9d72&"
import script from "./PeoplePicker.ts?vue&type=script&lang=ts&"
export * from "./PeoplePicker.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports